import { Wordmark } from "./Wordmark";

type Column = { title: string; links: Array<{ label: string; href: string; external?: boolean }> };

const columns: Column[] = [
  {
    title: "Product",
    links: [
      { label: "Overview", href: "#product" },
      { label: "Why Jotty", href: "#why" },
      { label: "FAQ", href: "#faq" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "Built by Kugie", href: "#about" },
      { label: "kugie.app", href: "https://kugie.app", external: true },
      {
        label: "Request an invite",
        href: "https://kugie.app/contact",
        external: true,
      },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy", href: "/legal/privacy" },
      { label: "Terms", href: "/legal/terms" },
    ],
  },
];

export function Footer() {
  return (
    <footer className="border-t border-[color:var(--line)] bg-glacial-canvas">
      <div className="mx-auto w-full max-w-[1280px] px-6 py-20 sm:px-10">
        <div className="grid gap-12 sm:grid-cols-2 md:grid-cols-[1.4fr_repeat(3,1fr)]">
          <div className="flex flex-col gap-5">
            <Wordmark />
            <p className="max-w-[36ch] text-sm text-[color:var(--ink-muted)]">
              Meeting notes for Indonesian teams. Bilingual by default. Built in
              Jakarta by Kugie.
            </p>
            <p className="max-w-[36ch] text-xs text-[color:var(--ink-subtle)]">
              Jotty is currently invite-only. Contact Kugie to try it.
            </p>
          </div>
          {columns.map((col) => (
            <div key={col.title} className="flex flex-col gap-3">
              <h3 className="text-xs font-medium uppercase tracking-[0.14em] text-[color:var(--ink-subtle)]">
                {col.title}
              </h3>
              <ul className="flex flex-col gap-2">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      target={link.external ? "_blank" : undefined}
                      rel={link.external ? "noopener noreferrer" : undefined}
                      className="text-sm text-[color:var(--ink-muted)] transition-colors duration-[var(--duration-micro)] hover:text-glacial-navy"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-20 flex flex-col gap-3 border-t border-[color:var(--line)] pt-8 text-xs text-[color:var(--ink-subtle)] sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} Jotty. Made in Jakarta.</p>
          <p>
            A{" "}
            <a
              href="https://kugie.app"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[color:var(--ink-muted)] underline decoration-[color:var(--line)] underline-offset-2 transition-colors hover:text-glacial-navy"
            >
              Kugie
            </a>{" "}
            product.
          </p>
        </div>
      </div>
    </footer>
  );
}
